import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'



export default {
    namespaced: true,
    state: {
        myJobsTrayAssigned : [],
        myJobsTrayPrepared : [],
        myJobsTrayDraft : [],
        myJobsTrayIncomplete : [],
    },

    getters: {
    },

    mutations: {
        setMyJobsTrayAll(state, groups) {
            state.myJobsTrayAssigned = groups['2'];
            state.myJobsTrayPrepared = groups['3'];
            state.myJobsTrayDraft = groups['4'];
            state.myJobsTrayIncomplete = groups['5'];
        },
        setMyJobsTrayAssigned (state, myJobsTrayAssigned) {
            state.myJobsTrayAssigned  = myJobsTrayAssigned
        },

        setMyJobsTrayPrepared (state, myJobsTrayPrepared) {
            state.myJobsTrayPrepared  = myJobsTrayPrepared
        },

        setMyJobsTrayDraft (state, myJobsTrayDraft) {
            state.myJobsTrayDraft  = myJobsTrayDraft
        },

        setMyJobsTrayIncomplete (state, myJobsTrayIncomplete) {
            state.myJobsTrayIncomplete  = myJobsTrayIncomplete
        },




    },

    actions: {
        async fetchMyJobsTrayV2({ commit }, { user_id }) {
            const token = localStorage.getItem('access_token');
            const config = getConfigAxios();
            const response = await axios.post(
                `${getBaseURLforBackEnd()}/api/myjobstray_v2`,
                { user_id },
                { ...config, headers: { ...config.headers, Authorization: `Bearer ${token}` } }
            );
            if (localStorage.getItem('access_token') !== token) {
                throw new Error('Login session changed while loading job trays');
            }
            const groups = response.data;
            if (!groups || ![2, 3, 4, 5].every(status => Array.isArray(groups[String(status)]))) {
                throw new Error('Invalid job trays response');
            }
            commit('setMyJobsTrayAll', groups);
            return groups;
        },
        /* eslint-disable no-console */
        
        // Dev experiment: HTTP-complete actions; legacy actions below are unchanged.
        fetchMyJobsTraySequential({
          commit
        }, payloadDatTo) {
          const datTo = {
            "user_id": payloadDatTo.user_id,
            "status_id": payloadDatTo.status_id
          };
          axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`;
          return axios.post(`${getBaseURLforBackEnd()}/api/myjobstray`, datTo, getConfigAxios()).then(res => {
            if (payloadDatTo.status_id === 2) {
              commit('setMyJobsTrayAssigned', res.data);
              return res.data;
            } else if (payloadDatTo.status_id === 3) {
              commit('setMyJobsTrayPrepared', res.data);
              return res.data;
            } else if (payloadDatTo.status_id === 4) {
              commit('setMyJobsTrayDraft', res.data);
              return res.data;
            } else if (payloadDatTo.status_id === 5) {
              commit('setMyJobsTrayIncomplete', res.data);
              return res.data;
            }
          });
        },
fetchMyJobsTray({commit},payloadDatTo) {
           const datTo = {
                "user_id": payloadDatTo.user_id,
                "status_id":  payloadDatTo.status_id
            }
            // console.log("datTo")
            // console.log(datTo)
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/myjobstray`,datTo,getConfigAxios())
                    .then((res)=>{
                        if(payloadDatTo.status_id === 2) {
                            commit('setMyJobsTrayAssigned', res.data)
                            resolve(res.data)
                            // console.log('setMyJobsTrayAssigned')
                        }else if(payloadDatTo.status_id === 3) {
                            commit('setMyJobsTrayPrepared', res.data)
                            resolve(res.data)
                            // console.log('setMyJobsTrayPrepared')
                        }else if(payloadDatTo.status_id === 4) {
                            commit('setMyJobsTrayDraft', res.data)
                            resolve(res.data)
                            // console.log('setMyJobsTrayDraft')
                        }else if(payloadDatTo.status_id === 5) {
                            commit('setMyJobsTrayIncomplete', res.data)
                            resolve(res.data)
                        }

                    })
                    .catch((err)=>{
                        reject(err)
                    })

            })
        }

    }
}